/**
 * Created by jjing on 7/17/2017.
 */
import request from "superagent";
import PropTypes from 'prop-types';
import GlobalConstants from "./Constants";
import NotificationManager from './CustomNotificationManager.js';

export function superAgentWithAuth(history) {
    this.history = history;
    //this.location = location;
    this.redirectCall = (res) => {
        redirectFun(res);
    }

    function redirectFun(res) {
        // const index = window.location.href.indexOf(window.location.origin) + window.location.origin.length;
        // window.location.href.slice(index);
        const redirectURL = window.location.pathname;

        console.dir('save redirects by authentication. ' + redirectURL);
        sessionStorage.setItem("redirect_url", redirectURL);

        const targetURL = res && res.get("location") ? res.get("location") : "/login";
        if(history)
            history.push({pathname: targetURL/*, state:{lastPathname: location.pathname}*/});
    }

    this._unauthorizedRedirect = function(req) {
        req.on('response', function (res) {
            if (res.status === 401) {
                redirectFun(res);
            }
        });
    };

    this.doPost = function (url){
        return request.post(url).use(this._unauthorizedRedirect);
    }

    this.doGet = function (url){
        return request.get(url).use(this._unauthorizedRedirect);
    }

    this.doPut = function (url){
        return request.put(url).use(this._unauthorizedRedirect);
    }

    this.doDelete = function (url){
        return request.delete(url).use(this._unauthorizedRedirect);
    }
};

/*
* Permission Control
* HOC function & Component Wrapper
* userPermissions: Array(User Permission item list)
* componentPermission: Array
* */
export const permissionCtrlHOC = (permission, userPermission) => {
    return function(component){
        return permissionCheck(permission, userPermission) ? component : null;
    };
}

export function permissionCheck(permission, userPermission) {
    let isPermissible = false;
    const permissionArray = JSON.parse(sessionStorage.getItem(GlobalConstants.SessionStoreKey.Permission));
    const currentUserPermissions = userPermission && userPermission.length > 0 ? userPermission : permissionArray;
    let permissionList = [];

    if (currentUserPermissions && currentUserPermissions.length > 0 && permission && permission.length > 0) {
        if (Array.isArray(permission)) {
            permission.forEach((permissionCore) => {
                if (Array.isArray(permissionCore)) {
                    permissionList = permissionList.concat(permissionCore);
                } else {
                    permissionList.push(permissionCore);
                }
            });
        } else {
            permissionList.push(permission);
        }

        const intersection = permissionList.filter(v => currentUserPermissions.includes(v));
        isPermissible = (intersection.length > 0);
    } else if (currentUserPermissions && currentUserPermissions.length > 0) {
        isPermissible = true;
    }
    return isPermissible;
};

export const PermissionCtrl = ({permission, userPermission, children, ...props}) => {
    if (permissionCheck(permission, userPermission)) {
        return children;
    } else {
        return null;
    }
}
PermissionCtrl.propTypes = {
    permission: PropTypes.array.isRequired,
    userPermission: PropTypes.array
}

export const NotificationType = {
    success: "success",
    info: "info",
    warning: "warning",
    error: "error"
}

/*

 */
//success, info, warning, error
export function openNotification(message, type) {
    switch (type) {
        case NotificationType.success :
            NotificationManager.success(message);
            break;
        case NotificationType.info :
            NotificationManager.info(message);
            break;
        case NotificationType.warning :
            NotificationManager.warn(message);
            break;
        case NotificationType.error :
            NotificationManager.error(message);
            break;
        default :
            break;
    }
    //notification[type]({
    //    message: title,
    //    description: message,
    //    duration: 6
    //});
}

export function hashCode(string) {
    let hash = 0, i, chr;
    if (string.length === 0) return hash;
    for (i = 0; i < string.length; i++) {
        chr = string.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};

export function getUrl(service, subUrl, tenantId) {
    const services = JSON.parse(sessionStorage.getItem('services'));
    const tid = tenantId ? tenantId : sessionStorage.getItem('tenantId');
    const uaid = sessionStorage.getItem('uaid');

    let url = services[service.key][service.ver];
    if (subUrl) {
        url += subUrl;
    }

    const params = 'tid=' + tid + '&uaid=' + uaid;
    url += ((url.indexOf('?') === -1) ? '?' : '&') + params;
    return url;
};

export function getPDMSUrl(env){
    const tid = sessionStorage.getItem('tenantId');
    const email = sessionStorage.getItem('username');
    return `https://www.ops${env}.pdms.plcm.cloud/api/rest/v1/user/login?tid=${tid}&email=${email}`;
}

export function saveLog(message, level='info'){
    const data = {level, message};
    request.post("/api/log/save")
        .set('Content-Type', 'application/json')
        .withCredentials().send(data)
        .end();
}

export const ROLES = {
    DEVICE_ADMIN: { label: "Device Admin", value: "DeviceAdmin" },
    DEVICE_OPERATOR: { label: "Device Operator", value: "DeviceOperator" },
    ENTERPRISE_ADMIN: { label: "Enterprise Admin", value: "EnterpriseAdmin" },
    LICENSE_ADMIN: { label: "License Admin", value: "LicenseAdmin" },
    USER_ADMIN: { label: "User Admin", value: "UserAdmin" },
    PDMSSP_ADMIN: { label: "PDMS-SP Admin", value: "PDMSSPAdmin" },
    PDMSSP_USER: { label: "PDMS-SP User", value: "PDMSSPUser" },
    OTD_ADMIN: { label: "OTD Admin", value: "OTDAdministrator" }
};


// WEBPACK FOOTER //
// ./src/commons/CommonUtils.js